"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import { useAuth } from "../../../_providers/Auth";
import { useMenu } from "../../../_providers/Menu";
import { CartLink } from "../../CartLink";
import {
  SlUserFollowing,
  SlUser,
  SlLogout,
  SlUserFollow,
  SlLogin,
} from "react-icons/sl";
import { META } from "../../../_graphql/meta";
import { Media } from "../../../_components/Media";
import { HiMenuAlt1 } from "react-icons/hi";
import { FiSearch } from "react-icons/fi";

import classes from "./index.module.scss";
import { AGUNG, logo } from "../../../_constants/index";
import { Product } from "../../../../payload/payload-types";
import { usePathname } from "next/navigation";

import {
  FaRegUser,
  FaCube,
  FaRegEnvelope,
  FaFilePen,
  FaAddressCard,
} from "react-icons/fa6";
import { GoTag } from "react-icons/go";
import { FaRegSave } from "react-icons/fa";
import Image from "next/image";

function NavLogo() {
  const { user } = useAuth();
  const {
    mainMenu,
    setMainMenu,
    subMenu,
    setSubMenu,
    search,
    setSearch,
    account,
    setAccount,
  } = useMenu();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {}, [results]);
  const pathname = usePathname();

  const handleChange = (e) => {
    if (e.target.value.trim() != "" && e.target.value.trim().length >= 3) {
      setSearchValue(e.target.value);
      getResults(e.target.value);
    } else {
      setResults([]);
    }
    setQuery(e.target.value);
  };

  useEffect(() => {
    setResults([]); // Clear results when the page changes
  }, [pathname]); // Trigger when route changes

  const displayMenu = () => {
    setMainMenu(!mainMenu);
  };

  const displaySearch = () => {
    setSearch(!search);
  };

  const displayMobileAccountMenu = () => {
    setAccount(!account);
  };

  const getFirstName = (name: string) => {
    let firstNameLastName = name.split(" ");
    return firstNameLastName[0];
  };

  const getResults = async (queryEntries) => {
    const queryT = `query {
            Products(where: {title: { like: "${queryEntries}" } }) {
            docs {
                id
                title
                slug
                ${META}
            }
        }
    }`;

    const docs: Product[] = await fetch(
      `${process.env.NEXT_PUBLIC_SERVER_URL}/api/graphql`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: queryT,
        }),
      }
    )
      ?.then((res) => res.json())
      ?.then((res) => {
        let allProducts = res?.data["Products"]?.docs;
        setResults(allProducts);
        // setLoaded(true);

        if (res.errors)
          throw new Error(res?.errors?.[0]?.message ?? "Error fetching docs");
        return res?.data["Products"]?.docs;
      });
  };
  return (
    <>
      <div className={classes.logoTopHeader}>
        <div className={classes.logoBlock}>
          <Link href={`${process.env.NEXT_PUBLIC_SERVER_URL}`}>
            <Image
              className={classes.logoImg}
              src={logo}
              alt={AGUNG}
              width={150}
              height={50}
              priority
            />
          </Link>
        </div>
        <div className={classes.inputBox}>
          <input
            type="text"
            className={classes.input}
            placeholder="Search for products or brands..."
            value={query}
            onChange={handleChange}
          />
          <ul className={classes.inputBoxResults}>
            {results &&
              results?.map((product, index) => {
                const {
                  meta: { image: metaImage },
                } = product;
                return (
                  <li key={index}>
                    <Link
                      href={
                        `${process.env.NEXT_PUBLIC_SERVER_URL}` +
                        "/products/" +
                        product.slug
                      }
                    >
                      <Media
                        key={index}
                        imgClassName={classes.imageProduct}
                        resource={metaImage}
                      />
                      {product.title}
                    </Link>
                  </li>
                );
              })}
            {results.length > 0 && <Link className={classes.allSearchLink}
                href={`${process.env.NEXT_PUBLIC_SERVER_URL}` + "/search?search=" +
                    searchValue}>See all search results</Link>}
          </ul>
        </div>
        <div className={classes.navBlock}>
          <nav
            className={[
              classes.nav,
              // fade the nav in on user load to avoid flash of content and layout shift
              // Vercel also does this in their own website header, see https://vercel.com
              user === undefined && classes.hide,
            ]
              .filter(Boolean)
              .join(" ")}
          >
            {user && (
              <Link
                href={`${process.env.NEXT_PUBLIC_SERVER_URL}/account`}
                className={classes.userIconLabel}
              >
                <SlUserFollowing size={25} />
                <span> Hi, {getFirstName(user?.name)}</span>
              </Link>
            )}
            {!user && (
              <>
                <Link href={`${process.env.NEXT_PUBLIC_SERVER_URL}/login`}>
                  Login
                </Link>
                /
                <Link
                  href={`${process.env.NEXT_PUBLIC_SERVER_URL}/create-account`}
                >
                  Register
                </Link>
              </>
            )}
            <CartLink />
          </nav>
        </div>
      </div>
      {/** Mobile starts */}
      <div className={classes.mobileHeader}>
        <div
          className={classes.mobileMenuHambuger}
          onClick={() => displayMenu()}
        >
          <HiMenuAlt1 size={25} />
        </div>
        <div className={classes.mobileLogo}>
          <Link href={`${process.env.NEXT_PUBLIC_SERVER_URL}`}>
            <Image
              className={classes.logoImg}
              src={logo}
              alt={AGUNG}
              width={150}
              height={50}
              priority
            />
          </Link>
        </div>
        <div
          className={classes.mobileAccountIcon}
          onClick={() => displayMobileAccountMenu()}
        >
          {user ? <SlUserFollowing size={25} /> : <SlUser size={25} />}
          <div
            className={[
              classes.mobileAccountDropDownSection,
              account === true && classes.showAccountMenu,
            ]
              .filter(Boolean)
              .join(" ")}
          >
            {user ? (
              <ul className={classes.accountMenuLinks}>
                <li>
                  <Link href={`${process.env.NEXT_PUBLIC_SERVER_URL}/account/`}>
                    {" "}
                    <FaRegUser size="16px" /> &nbsp; Account
                  </Link>
                </li>
                <li>
                  <Link href={`${process.env.NEXT_PUBLIC_SERVER_URL}/orders/`}>
                    {" "}
                    <FaCube size="16px" />
                    &nbsp; Orders
                  </Link>
                </li>
                <li>
                  <Link
                    href={`${process.env.NEXT_PUBLIC_SERVER_URL}/customer/inbox/`}
                  >
                    <FaRegEnvelope size="16px" />
                    &nbsp; Inbox
                  </Link>
                </li>
                <li>
                  <Link
                    href={`${process.env.NEXT_PUBLIC_SERVER_URL}/customer/reviews/`}
                  >
                    {" "}
                    <FaFilePen size="16px" />
                    &nbsp; Reviews
                  </Link>
                </li>
                <li>
                  <Link
                    href={`${process.env.NEXT_PUBLIC_SERVER_URL}/customer/voucher/`}
                  >
                    {" "}
                    <GoTag size="16px" />
                    &nbsp; Voucher
                  </Link>
                </li>
                <li>
                  <Link
                    href={`${process.env.NEXT_PUBLIC_SERVER_URL}/customer/wishlist/`}
                  >
                    {" "}
                    <FaRegSave size="16px" />
                    &nbsp; Wishlist
                  </Link>
                </li>
                <li>
                  <Link
                    href={`${process.env.NEXT_PUBLIC_SERVER_URL}/customer/address-book/`}
                  >
                    <FaAddressCard size="16px" /> &nbsp; Address Book
                  </Link>
                </li>
                <li>
                  <Link
                    href={`${process.env.NEXT_PUBLIC_SERVER_URL}/customer/account-management/`}
                  >
                    <FaAddressCard size="16px" /> &nbsp; Account Management
                  </Link>
                </li>
                <li>
                  <Link href={`${process.env.NEXT_PUBLIC_SERVER_URL}/logout/`}>
                    <SlLogout size="16px" /> &nbsp; Logout
                  </Link>
                </li>
              </ul>
            ) : (
              <ul className={classes.accountMenuLinks}>
                <li>
                  <Link
                    href={`${process.env.NEXT_PUBLIC_SERVER_URL}/create-account/`}
                  >
                    {" "}
                    <SlUserFollow size="16px" /> &nbsp; Create Account
                  </Link>
                </li>
                <li>
                  <Link href={`${process.env.NEXT_PUBLIC_SERVER_URL}/login/`}>
                    {" "}
                    <SlLogin size="16px" /> &nbsp; Login
                  </Link>
                </li>
              </ul>
            )}
          </div>
        </div>

        <div
          className={classes.mobileSearchIcon}
          onClick={() => displaySearch()}
        >
          <FiSearch size={25} />
        </div>
        <div className={classes.mobileCartIcon}>
          <CartLink />
        </div>
      </div>
    </>
  );
}

export default NavLogo;
